import type { ReactNode } from 'react';

import { useMultiStep } from '#/components/Form/MultiStepForm/useMultiStep';
import { H5 } from '#/components/Text/H5';
import { colors } from '#/theme/theme';

import { MultiStepFormBaseHeader } from './MultiStepFormBaseHeader';

export type HeaderProps = {
  steps: {
    title?: string;
    ignoreInNav?: boolean;
  }[];
  submitDraft?: () => Promise<void>;
  errors: string[][];
  trackingTitle?: string;
  title?: string;
  singlePage?: boolean;
  edited: boolean;
  isDraft?: boolean;
  cartDropdownButton?: ReactNode;
};

export function MultiStepFormHeader({
  steps,
  submitDraft,
  errors,
  trackingTitle,
  title,
  singlePage,
  edited,
  isDraft,
  cartDropdownButton,
}: HeaderProps) {
  const { currentStep, navigateToStep } = useMultiStep();

  const getStepQaId = (index: number) => {
    if (index > currentStep) {
      return 'multi-form-header-future-step';
    }
    if (index === currentStep) {
      return 'multi-form-header-current-step';
    }
    return 'multi-form-header-past-step';
  };

  return (
    <MultiStepFormBaseHeader
      submitDraft={submitDraft}
      edited={edited}
      trackingTitle={trackingTitle}
      title={title}
      isDraft={isDraft}
      cartDropdownButton={cartDropdownButton}
    >
      {!singlePage && (
        <div style={{ display: 'flex' }}>
          {steps.map((step, index) => {
            const hasError = Boolean(errors?.[index]?.length);
            return (
              <div
                key={step.title}
                style={{
                  width: (100 / steps.length).toFixed(2) + '%',
                  height: 50,
                  color: (() => {
                    if (hasError) return colors.alertRed;
                    if (index === currentStep) return colors.brandBlue;
                    if (index < currentStep) return colors.mediumContentGrey;
                    return colors.elementGrey;
                  })(),
                  boxShadow: `0 4px ${(() => {
                    if (hasError) return colors.alertRed;
                    if (index === currentStep) return colors.brandBlue;
                    if (index < currentStep) return '#5dc2f1';
                    return colors.selectionGrey;
                  })()}`,
                  borderLeft: index > 0 ? '1px solid #eaeaea' : undefined,
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => navigateToStep(index)}
                    disabled={index >= currentStep}
                    data-qa-id={getStepQaId(index)}
                  >
                    <H5
                      style={{ textAlign: 'center', margin: 0, fontSize: 14 }}
                    >
                      {index + 1}. {step.title}
                    </H5>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </MultiStepFormBaseHeader>
  );
}
